export const environment = {
  production: true,
  API_URL: 'https://sgs-api-prd.18mc.com.br',
  FIXED_EVENT: {
    uuid: '9CD47732-3978-4063-BBC4-31D19CE14D5A',
    createdAt: '2026-06-03T03:00:00.000+00:00',
    name: 'Bonde Pela Vida - 6ª edição',
    observation: 'Texto de Observação',
    shortKey: 'bpv6e',
    startAt: '2026-06-03T03:00:00.000+00:00',
    endAt: '2026-07-06T03:00:00.000+00:00'
  }
};
